module.exports = __webpack_public_path__ + "static/healthImage-01afeb3fa0a0954ee12525ac8e578195.png";